import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-full bg-white py-5 px-3 flex flex-col items-stretch" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex-initial flex-shrink-0 self-center text-xl text-gray-800 mb-3" }, " 课表云同步 ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex-initial flex-shrink-0 self-center text-sm mb-5 text-gray-600" }, " 本地数据与服务器不一致，需要进行同步 ", -1)
const _hoisted_4 = { class: "h-0 flex-grow flex justify-between" }
const _hoisted_5 = { class: "flex-grow flex flex-col my-0 mx-1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "self-center text-sm font-bold mb-1 text-gray-600" }, " 本地新增课程 ", -1)
const _hoisted_7 = { class: "self-center" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 使用本地课表 ")
const _hoisted_9 = { class: "flex-grow flex flex-col my-0 mx-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "self-center text-sm font-bold mb-1 text-gray-600" }, " 云端新增课程 ", -1)
const _hoisted_11 = { class: "self-center" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 使用云端课表 ")
const _hoisted_13 = { class: "flex-grow-0 flex-shrink-0 flex justify-end my-4 mx-5" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 合并 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lesson_list = _resolveComponent("lesson-list")!
  const _component_f_button = _resolveComponent("f-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_lesson_list, { "selected-courses": _ctx.selectedCoursesOnlyInLocal }, null, 8, ["selected-courses"]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_f_button, {
            shape: "circle",
            onClick: _cache[0] || (_cache[0] = () => _ctx.handleChoosen('local'))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_lesson_list, { "selected-courses": _ctx.selectedCoursesOnlyInDataBase }, null, 8, ["selected-courses"]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_f_button, {
            shape: "circle",
            depressed: "",
            onClick: _cache[1] || (_cache[1] = () => _ctx.handleChoosen('cloud'))
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_f_button, {
        shape: "circle",
        type: "primary",
        onClick: _cache[2] || (_cache[2] = () => _ctx.handleChoosen('both'))
      }, {
        default: _withCtx(() => [
          _hoisted_14
        ]),
        _: 1
      })
    ])
  ]))
}